import { Auth } from 'aws-amplify';
import store from '../store/index';

export default (to, from, next) => {
  // on each time route change - auth needs to be checked?
  // then remove this if condition
  if (store.getters['users/isMeSignedIn']) {
    next();
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser().then((data) => {
      if (data && data.signInUserSession) {
        store.dispatch('users/setMe', data);
        next();
      }
    }).catch((e) => {
      console.log(e);
      store.dispatch('users/resetMe');
      next({ path: '/auth' });
    });
  }

  next();
};
